import { TOKEN_STORAGE_KEY } from '@/common/constants';

export const getToken = () => ({
  accessToken: localStorage.getItem(TOKEN_STORAGE_KEY.accessToken)
});

export const saveToken = ({ token }) => {
  localStorage.setItem(TOKEN_STORAGE_KEY.accessToken, token.replace('Bearer ', ''));
};

export const clearToken = () => {
  localStorage.setItem(TOKEN_STORAGE_KEY.accessToken, '');
};

export const getRoles = () => ({
  roles: localStorage.getItem(TOKEN_STORAGE_KEY.roles)
});

export const saveRoles = ({ roles }) => {
  localStorage.setItem(TOKEN_STORAGE_KEY.roles, roles);
};
